export const bottomNavOffset = 50;
export const bottomNavBarHeight = bottomNavOffset + 'px';
export const bottomNavItemIconSize = 24;
export const overflowMenuItemHeight = 40;
